import qs from 'qs';

const stringify = (params: any) => qs.stringify(params, { skipNulls: true });

export const NAV = {
  octweb: 'https://octoberweb.ru/',
  home: '/',
  about: '/about/',
  contacts: '/contacts/',
  prices: '/prices/',
  faq: '/qna/',
  privacyPolicy: '/privacy-policy/',
  publicOffer: '/public-offer/',

  reviewList: '/reviews/',

  serviceList: '/services/',
  serviceDetail: (slug: string) => `/services/${slug}/`,

  blogList: (params?: { category?: string }) =>
    `/posts/${params ? `?${stringify(params)}` : ''}`,
  blogDetail: (slug: string) => `/posts/${slug}/`,
};
